import React, { useState, useEffect } from 'react';
import DashLayout from '../componets/layout/DashLayout';
import './sections.css';
import { supabase } from '../supabaseClient';
import Preloader from '../componets/layout/preloader';

const Sections = () => {
    const [activeTab, setActiveTab] = useState('navbar');
    const [eventModalOpen, setEventModalOpen] = useState(false);
    const [navModalOpen, setNavModalOpen] = useState(false);
    const [benefitModalOpen, setBenefitModalOpen] = useState(false);
    const [featureModalOpen, setFeatureModalOpen] = useState(false);
    const [tagModalOpen, setTagModalOpen] = useState(false);

    const [navData, setNavData] = useState([]);
    const [heroData, setHeroData] = useState(null);
    const [heroStats, setHeroStats] = useState([]);
    const [aboutData, setAboutData] = useState(null);
    const [featureCards, setFeatureCards] = useState([]);
    const [bookingData, setBookingData] = useState(null);
    const [bookingBenefits, setBookingBenefits] = useState([]);
    const [featuredData, setFeaturedData] = useState([]);
    const [eventTags, setEventTags] = useState([]);
    const [loading, setLoading] = useState(true);

    const [navForm, setNavForm] = useState({ en: "", ar: "" });
    const [eventForm, setEventForm] = useState({
        title: "", subtitle: "", date: "", day: "", time: "", location: "", price: "", button: "Book Now"
    });
    const [featForm, setFeatForm] = useState({
        titleEn: "", titleAr: "", descEn: "", descAr: "", iconUrl: ""
    });
    const [benForm, setBenForm] = useState({
        titleEn: "", titleAr: "", descEn: "", descAr: "", img: ""
    });
    const [tagForm, setTagForm] = useState({ en: "", ar: "" });
    const [heroForm, setHeroForm] = useState({
        titleEn: "", titleAr: "", titleEn2: "", titleAr2: "", titleEn3: "", titleAr3: "", subtextEn: "", subtextAr: ""
    });
    const [aboutForm, setAboutForm] = useState({
        titleEn: "", titleAr: "", titleEn2: "", titleAr2: "", desEn: "", desAr: ""
    });
    const [bookForm, setBookForm] = useState({
        secTitleEn: "", secTitleAr: "", secSubEn: "", secSubAr: "", 
        formTitleEn: "", formTitleAr: "", btnText: "", 
        supportTitle: "", supportEmail: "", supportPhone: ""
    });

    useEffect(() => {
        const getData = async () => {
            const { data: nav } = await supabase.from('nav').select('*');
            const { data: hero } = await supabase.from('herosec').select('*');
            const { data: stats } = await supabase.from('hero-statistics').select('*');
            const { data: about } = await supabase.from('about').select('*');
            const { data: features } = await supabase.from('feature_cards').select('*');
            const { data: booking } = await supabase.from('booking').select('*');
            const { data: benefits } = await supabase.from('booking_benefits').select('*');
            const { data: featured } = await supabase.from('feturad_events').select('*');
            const { data: tags } = await supabase.from('event_tags').select('*');
            if (nav) setNavData(nav);
            if (hero && hero[0]) {
                setHeroData(hero[0]);
                setHeroForm({
                    titleEn: hero[0].hero_title_en || "",
                    titleAr: hero[0].hero_title_ar || "",
                    titleEn2: hero[0].hero_title_en2 || "",
                    titleAr2: hero[0].hero_title_ar2 || "",
                    titleEn3: hero[0].hero_title_en3 || "",
                    titleAr3: hero[0].hero_title_ar3 || "",
                    subtextEn: hero[0].hero_subtext_en || "",
                    subtextAr: hero[0].hero_subtext_ar || ""
                });
            }
            if (stats) setHeroStats(stats);
            if (about && about[0]) {
                setAboutData(about[0]);
                setAboutForm({
                    titleEn: about[0].title_en || "",
                    titleAr: about[0].tittl_ar || "",
                    titleEn2: about[0].title_en2 || "",
                    titleAr2: about[0].title_er2 || "",
                    desEn: about[0].des_en || "",
                    desAr: about[0].des_ar || ""
                });
            }
            if (features) setFeatureCards(features);
            if (booking && booking[0]) {
                setBookingData(booking[0]);
                setBookForm({
                    secTitleEn: booking[0].section_title_en || "",
                    secTitleAr: booking[0].section_title_ar || "",
                    secSubEn: booking[0].section_subtitle_en || "",
                    secSubAr: booking[0].section_subtitle_ar || "",
                    formTitleEn: booking[0].form_title_en || "",
                    formTitleAr: booking[0].form_title_ar || "",
                    btnText: booking[0].button_text_en || "",
                    supportTitle: booking[0].support_title_en || "",
                    supportEmail: booking[0].support_email || "",
                    supportPhone: booking[0].support_phone || ""
                });
            }
            if (benefits) setBookingBenefits(benefits);
            if (featured) setFeaturedData(featured);
            if (tags) setEventTags(tags);
            setLoading(false);
        };
        getData();
    }, []);

    const saveHero = async () => {
        await supabase.from('herosec').update({
            hero_title_en: heroForm.titleEn,
            hero_title_ar: heroForm.titleAr,
            hero_title_en2: heroForm.titleEn2,
            hero_title_ar2: heroForm.titleAr2,
            hero_title_en3: heroForm.titleEn3,
            hero_title_ar3: heroForm.titleAr3,
            hero_subtext_en: heroForm.subtextEn,
            hero_subtext_ar: heroForm.subtextAr
        }).eq('id', heroData.id);
    };

    const saveAbout = async () => {
        await supabase.from('about').update({
            title_en: aboutForm.titleEn,
            tittl_ar: aboutForm.titleAr,
            title_en2: aboutForm.titleEn2,
            title_er2: aboutForm.titleAr2,
            des_en: aboutForm.desEn,
            des_ar: aboutForm.desAr
        }).eq('id', aboutData.id);
    };

    const saveBooking = async () => {
        await supabase.from('booking').update({
            section_title_en: bookForm.secTitleEn,
            section_title_ar: bookForm.secTitleAr,
            section_subtitle_en: bookForm.secSubEn,
            section_subtitle_ar: bookForm.secSubAr,
            form_title_en: bookForm.formTitleEn,
            form_title_ar: bookForm.formTitleAr,
            button_text_en: bookForm.btnText,
            support_title_en: bookForm.supportTitle,
            support_email: bookForm.supportEmail,
            support_phone: bookForm.supportPhone
        }).eq('id', bookingData.id);
    };

    const createNavLink = async (e) => {
        e.preventDefault();
        const { data: inserted, error } = await supabase.from('nav').insert([{
            label_en: navForm.en,
            label_ar: navForm.ar
        }]).select();
        if (!error && inserted) {
            setNavData(prev => [...prev, inserted[0]]);
            setNavModalOpen(false);
        }
    };

    const createFeaturedEvent = async (e) => {
        e.preventDefault();
        const { data: inserted, error } = await supabase.from('feturad_events').insert([{
            title_en: eventForm.title,
            subtitle: eventForm.subtitle,
            event_date: eventForm.date,
            day: eventForm.day,
            event_time: eventForm.time,
            location_en: eventForm.location,
            starting_price: eventForm.price,
            cta_button_text_en: eventForm.button
        }]).select();
        if (!error && inserted) {
            setFeaturedData(prev => [...prev, inserted[0]]);
            setEventModalOpen(false);
        }
    };

    const createFeatureCard = async (e) => {
        e.preventDefault();
        const { data: inserted, error } = await supabase.from('feature_cards').insert([{
            title_en: featForm.titleEn,
            title_ar: featForm.titleAr,
            description_en: featForm.descEn,
            description_ar: featForm.descAr,
            icon_url: featForm.iconUrl
        }]).select();
        if (!error && inserted) {
            setFeatureCards(prev => [...prev, inserted[0]]);
            setFeatureModalOpen(false);
        }
    };

    const createBenefit = async (e) => {
        e.preventDefault();
        const { data: inserted, error } = await supabase.from('booking_benefits').insert([{
            title_en: benForm.titleEn,
            title_ar: benForm.titleAr,
            description_en: benForm.descEn,
            description_ar: benForm.descAr,
            img: benForm.img
        }]).select();
        if (!error && inserted) {
            setBookingBenefits(prev => [...prev, inserted[0]]);
            setBenefitModalOpen(false);
        }
    };

    const createTag = async (e) => {
        e.preventDefault();
        const { data: inserted, error } = await supabase.from('event_tags').insert([{
            Tag_en: tagForm.en,
            tag_ar: tagForm.ar
        }]).select();
        if (!error && inserted) {
            setEventTags(prev => [...prev, inserted[0]]);
            setTagModalOpen(false);
        }
    };

    const handleDeleteNav = async (id) => {
        await supabase.from('nav').delete().eq('id', id);
        setNavData(prev => prev.filter(item => item.id !== id));
    };

    const handleDeleteFeatureCard = async (id) => {
        await supabase.from('feature_cards').delete().eq('id', id);
        setFeatureCards(prev => prev.filter(item => item.id !== id));
    };

    const handleDeleteBenefit = async (id) => {
        await supabase.from('booking_benefits').delete().eq('id', id);
        setBookingBenefits(prev => prev.filter(item => item.id !== id));
    };

    const handleDeleteTag = async (id) => {
        await supabase.from('event_tags').delete().eq('id', id);
        setEventTags(prev => prev.filter(item => item.id !== id));
    };

    return (
        <>
                    <Preloader />

            {navModalOpen && (
                <div className="sec-overlay">
                    <div className="sec-modal">
                        <div className="sec-modal-header">
                            <h2 className="sec-modal-title">Add New Link</h2>
                            <svg className="sec-modal-close" onClick={() => setNavModalOpen(false)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </div>
                        <div className="sec-modal-body">
                            <form className="sec-form" onSubmit={createNavLink}>
                                <div className="sec-form-row">
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Link Text (EN)</label>
                                        <input required type="text" className="sec-form-input" onChange={(e) => setNavForm({...navForm, en: e.target.value})} />
                                    </div>
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Link Text (AR)</label>
                                        <input required type="text" className="sec-form-input" dir="rtl" onChange={(e) => setNavForm({...navForm, ar: e.target.value})} />
                                    </div>
                                </div>
                                <div className="sec-form-footer">
                                    <button type="button" className="sec-cancel-btn" onClick={() => setNavModalOpen(false)}>Cancel</button>
                                    <button type="submit" className="sec-save-btn">
                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 3H7L3 7v10a1 1 0 001 1h13a1 1 0 001-1V4a1 1 0 00-1-1zM7 3v5h7V3M7 13h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                        Save Link
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {featureModalOpen && (
                <div className="sec-overlay">
                    <div className="sec-modal">
                        <div className="sec-modal-header">
                            <h2 className="sec-modal-title">Add New Feature</h2>
                            <svg className="sec-modal-close" onClick={() => setFeatureModalOpen(false)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </div>
                        <div className="sec-modal-body">
                            <form className="sec-form" onSubmit={createFeatureCard}>
                                <div className="sec-form-row">
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Title (EN)</label>
                                        <input required type="text" className="sec-form-input" onChange={(e) => setFeatForm({...featForm, titleEn: e.target.value})} />
                                    </div>
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Title (AR)</label>
                                        <input required type="text" className="sec-form-input" dir="rtl" onChange={(e) => setFeatForm({...featForm, titleAr: e.target.value})} />
                                    </div>
                                </div>
                                <div className="sec-form-row">
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Description (EN)</label>
                                        <input required type="text" className="sec-form-input" onChange={(e) => setFeatForm({...featForm, descEn: e.target.value})} />
                                    </div>
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Description (AR)</label>
                                        <input required type="text" className="sec-form-input" dir="rtl" onChange={(e) => setFeatForm({...featForm, descAr: e.target.value})} />
                                    </div>
                                </div>
                                <div className="sec-form-field">
                                    <label className="sec-form-label">Icon URL</label>
                                    <input required type="text" className="sec-form-input" placeholder="https://example.com/icon.png" onChange={(e) => setFeatForm({...featForm, iconUrl: e.target.value})} />
                                </div>
                                <div className="sec-form-footer">
                                    <button type="button" className="sec-cancel-btn" onClick={() => setFeatureModalOpen(false)}>Cancel</button>
                                    <button type="submit" className="sec-save-btn">
                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 3H7L3 7v10a1 1 0 001 1h13a1 1 0 001-1V4a1 1 0 00-1-1zM7 3v5h7V3M7 13h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                        Save Feature
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {benefitModalOpen && (
                <div className="sec-overlay">
                    <div className="sec-modal">
                        <div className="sec-modal-header">
                            <h2 className="sec-modal-title">Add New Benefit</h2>
                            <svg className="sec-modal-close" onClick={() => setBenefitModalOpen(false)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </div>
                        <div className="sec-modal-body">
                            <form className="sec-form" onSubmit={createBenefit}>
                                <div className="sec-form-row">
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Title (EN)</label>
                                        <input required type="text" className="sec-form-input" onChange={(e) => setBenForm({...benForm, titleEn: e.target.value})} />
                                    </div>
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Title (AR)</label>
                                        <input required type="text" className="sec-form-input" dir="rtl" onChange={(e) => setBenForm({...benForm, titleAr: e.target.value})} />
                                    </div>
                                </div>
                                <div className="sec-form-row">
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Description (EN)</label>
                                        <input required type="text" className="sec-form-input" onChange={(e) => setBenForm({...benForm, descEn: e.target.value})} />
                                    </div>
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Description (AR)</label>
                                        <input required type="text" className="sec-form-input" dir="rtl" onChange={(e) => setBenForm({...benForm, descAr: e.target.value})} />
                                    </div>
                                </div>
                                <div className="sec-form-field">
                                    <label className="sec-form-label">Image URL</label>
                                    <input required type="text" className="sec-form-input" placeholder="https://example.com/img.png" onChange={(e) => setBenForm({...benForm, img: e.target.value})} />
                                </div>
                                <div className="sec-form-footer">
                                    <button type="button" className="sec-cancel-btn" onClick={() => setBenefitModalOpen(false)}>Cancel</button>
                                    <button type="submit" className="sec-save-btn">
                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 3H7L3 7v10a1 1 0 001 1h13a1 1 0 001-1V4a1 1 0 00-1-1zM7 3v5h7V3M7 13h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                        Save Benefit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {tagModalOpen && (
                <div className="sec-overlay">
                    <div className="sec-modal">
                        <div className="sec-modal-header">
                            <h2 className="sec-modal-title">Add New Tag</h2>
                            <svg className="sec-modal-close" onClick={() => setTagModalOpen(false)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </div>
                        <div className="sec-modal-body">
                            <form className="sec-form" onSubmit={createTag}>
                                <div className="sec-form-row">
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Tag (EN)</label>
                                        <input required type="text" className="sec-form-input" onChange={(e) => setTagForm({...tagForm, en: e.target.value})} />
                                    </div>
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Tag (AR)</label>
                                        <input required type="text" className="sec-form-input" dir="rtl" onChange={(e) => setTagForm({...tagForm, ar: e.target.value})} />
                                    </div>
                                </div>
                                <div className="sec-form-footer">
                                    <button type="button" className="sec-cancel-btn" onClick={() => setTagModalOpen(false)}>Cancel</button>
                                    <button type="submit" className="sec-save-btn">
                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 3H7L3 7v10a1 1 0 001 1h13a1 1 0 001-1V4a1 1 0 00-1-1zM7 3v5h7V3M7 13h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                        Save Tag
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {eventModalOpen && (
                <div className="sec-overlay">
                    <div className="sec-modal">
                        <div className="sec-modal-header">
                            <h2 className="sec-modal-title">Add New Event</h2>
                            <svg className="sec-modal-close" onClick={() => setEventModalOpen(false)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </div>
                        <div className="sec-modal-body">
                            <form className="sec-form" onSubmit={createFeaturedEvent}>
                                <div className="sec-form-field">
                                    <label className="sec-form-label">Event Title</label>
                                    <input required type="text" className="sec-form-input" onChange={(e) => setEventForm({...eventForm, title: e.target.value})} />
                                </div>
                                <div className="sec-form-field">
                                    <label className="sec-form-label">Subtitle</label>
                                    <input required type="text" className="sec-form-input" onChange={(e) => setEventForm({...eventForm, subtitle: e.target.value})} />
                                </div>
                                <div className="sec-form-row">
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Date</label>
                                        <input required type="date" className="sec-form-input" onChange={(e) => setEventForm({...eventForm, date: e.target.value})} />
                                    </div>
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Day</label>
                                        <input required type="text" className="sec-form-input" placeholder="e.g., Friday" onChange={(e) => setEventForm({...eventForm, day: e.target.value})} />
                                    </div>
                                </div>
                                <div className="sec-form-row">
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Time</label>
                                        <input required type="time" className="sec-form-input" onChange={(e) => setEventForm({...eventForm, time: e.target.value})} />
                                    </div>
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Location</label>
                                        <input required type="text" className="sec-form-input" onChange={(e) => setEventForm({...eventForm, location: e.target.value})} />
                                    </div>
                                </div>
                                <div className="sec-form-row">
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Price</label>
                                        <input required type="text" className="sec-form-input" placeholder="$45" onChange={(e) => setEventForm({...eventForm, price: e.target.value})} />
                                    </div>
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Button Text</label>
                                        <input required type="text" className="sec-form-input" defaultValue="Book Now" onChange={(e) => setEventForm({...eventForm, button: e.target.value})} />
                                    </div>
                                </div>
                                <div className="sec-form-footer">
                                    <button type="button" className="sec-cancel-btn" onClick={() => setEventModalOpen(false)}>Cancel</button>
                                    <button type="submit" className="sec-save-btn">
                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 3H7L3 7v10a1 1 0 001 1h13a1 1 0 001-1V4a1 1 0 00-1-1zM7 3v5h7V3M7 13h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                        Save Event
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            <DashLayout title="Website Sections" active="sections">

                <div className="sec-top">
                    <h1 className="sec-title">Website Sections</h1>
                    <p className="sec-sub">Manage your landing page content sections</p>
                </div>

                <div className="sec-tabs">
                    <button className={`sec-tab ${activeTab === 'navbar' ? 'sec-tab--active' : ''}`} onClick={() => setActiveTab('navbar')}>
                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 5h16M2 10h16M2 15h16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
                        Navbar
                    </button>
                    <button className={`sec-tab ${activeTab === 'upcoming' ? 'sec-tab--active' : ''}`} onClick={() => setActiveTab('upcoming')}>
                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 2l2.39 5.26L18 8.27l-4 3.9.94 5.5L10 15l-4.94 2.67.94-5.5-4-3.9 5.61-.01z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></svg>
                        Hero
                    </button>
                    <button className={`sec-tab ${activeTab === 'about' ? 'sec-tab--active' : ''}`} onClick={() => setActiveTab('about')}>
                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="3" width="16" height="14" rx="2" stroke="currentColor" strokeWidth="1.5"/><path d="M6 7h8M6 10h8M6 13h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
                        About
                    </button>
                    <button className={`sec-tab ${activeTab === 'booking' ? 'sec-tab--active' : ''}`} onClick={() => setActiveTab('booking')}>
                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 6a2 2 0 012-2h10a2 2 0 012 2v2a1.5 1.5 0 000 4v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-2a1.5 1.5 0 000-4V6z" stroke="currentColor" strokeWidth="1.5"/><path d="M3 8h14" stroke="currentColor" strokeWidth="1.5"/><path d="M7 6v2M13 6v2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M7 11h6M7 13h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
                        Booking
                    </button>
                    <button className={`sec-tab ${activeTab === 'featured' ? 'sec-tab--active' : ''}`} onClick={() => setActiveTab('featured')}>
                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="4" width="14" height="13" rx="2" stroke="currentColor" strokeWidth="1.5"/><path d="M3 8h14M7 2v4M13 2v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
                        Featured Events
                    </button>
                    <button className={`sec-tab ${activeTab === 'testimonials' ? 'sec-tab--active' : ''}`} onClick={() => setActiveTab('testimonials')}>
                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 4a2 2 0 012-2h12a2 2 0 012 2v8a2 2 0 01-2 2H6l-4 4V4z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></svg>
                        Footer
                    </button>
                </div>

                {loading ? (
                    <p>Loading...</p>
                ) : (
                    <>
                        {activeTab === 'navbar' && (
                            <div className="sec-content">
                                <div className="sec-block">
                                    <h3 className="sec-block-title">Brand Settings</h3>
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Brand Name</label>
                                        <input type="text" className="sec-form-input" defaultValue="FoxEvents" />
                                    </div>
                                </div>
                                <div className="sec-block">
                                    <div className="sec-block-header">
                                        <h3 className="sec-block-title">Navigation Links</h3>
                                        <button className="sec-add-btn" onClick={() => setNavModalOpen(true)}>
                                            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 4v12M4 10h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                                            Add Link
                                        </button>
                                    </div>
                                    <div className="sec-nav-table">
                                        <div className="sec-nav-head">
                                            <span>Link Text (EN)</span>
                                            <span>Link Text (AR)</span>
                                            <span>Delete</span>
                                        </div>
                                        {navData.map((item) => (
                                            <div className="sec-nav-row" key={item.id}>
                                                <input type="text" className="sec-form-input" defaultValue={item.label_en} />
                                                <input type="text" className="sec-form-input" defaultValue={item.label_ar} dir="rtl" />
                                                <button className="sec-del-btn" onClick={() => handleDeleteNav(item.id)}>
                                                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 5h14M8 5V3h4v2M6 5l1 11h6l1-11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="sec-block">
                                    <h3 className="sec-block-title">CTA Button</h3>
                                    <div className="sec-form-row">
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Button Text</label>
                                            <input type="text" className="sec-form-input" defaultValue="Sign In" />
                                        </div>
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Button Link</label>
                                            <input type="text" className="sec-form-input" defaultValue="/signin" />
                                        </div>
                                    </div>
                                </div>
                                <div className="sec-footer">
                                    <button className="sec-save-changes-btn">
                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 3H7L3 7v10a1 1 0 001 1h13a1 1 0 001-1V4a1 1 0 00-1-1zM7 3v5h7V3M7 13h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                        Save Changes
                                    </button>
                                </div>
                            </div>
                        )}

                        {activeTab === 'upcoming' && (
                            <div className="sec-content">
                                <div className="sec-block">
                                    <h3 className="sec-block-title">Hero Image</h3>
                                    <div className="sec-img-row">
                                        <img src={heroData?.['hero-img']} alt="hero" className='sec-img-preview' />
                                        <button className="sec-upload-img-btn">
                                            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 13V4M10 4L7 7M10 4l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 13v3a1 1 0 001 1h12a1 1 0 001-1v-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
                                            Upload Event Image
                                        </button>
                                    </div>
                                </div>
                                <div className="sec-block">
                                    <h3 className="sec-block-title">Hero Heading</h3>
                                    <div className="sec-form-row">
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Title Part 1 (EN)</label>
                                            <input type="text" className="sec-form-input" value={heroForm.titleEn} onChange={(e) => setHeroForm({...heroForm, titleEn: e.target.value})} />
                                        </div>
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Title Part 1 (AR)</label>
                                            <input type="text" className="sec-form-input" dir="rtl" value={heroForm.titleAr} onChange={(e) => setHeroForm({...heroForm, titleAr: e.target.value})} />
                                        </div>
                                    </div>
                                    <div className="sec-form-row">
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Highlighted Word (EN)</label>
                                            <input type="text" className="sec-form-input" value={heroForm.titleEn2} onChange={(e) => setHeroForm({...heroForm, titleEn2: e.target.value})} />
                                        </div>
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Highlighted Word (AR)</label>
                                            <input type="text" className="sec-form-input" dir="rtl" value={heroForm.titleAr2} onChange={(e) => setHeroForm({...heroForm, titleAr2: e.target.value})} />
                                        </div>
                                    </div>
                                    <div className="sec-form-row">
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Title Part 3 (EN)</label>
                                            <input type="text" className="sec-form-input" value={heroForm.titleEn3} onChange={(e) => setHeroForm({...heroForm, titleEn3: e.target.value})} />
                                        </div>
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Title Part 3 (AR)</label>
                                            <input type="text" className="sec-form-input" dir="rtl" value={heroForm.titleAr3} onChange={(e) => setHeroForm({...heroForm, titleAr3: e.target.value})} />
                                        </div>
                                    </div>
                                    <div className="sec-form-row">
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Description (EN)</label>
                                            <textarea className="sec-form-textarea" value={heroForm.subtextEn} onChange={(e) => setHeroForm({...heroForm, subtextEn: e.target.value})}></textarea>
                                        </div>
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Description (AR)</label>
                                            <textarea className="sec-form-textarea" dir="rtl" value={heroForm.subtextAr} onChange={(e) => setHeroForm({...heroForm, subtextAr: e.target.value})}></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div className="sec-block">
                                    <h3 className="sec-block-title">Stats Cards</h3>
                                    <div className="sec-stats-grid">
                                        {heroStats.map((item) => (
                                            <div className="sec-stat-edit-card" key={item.id}>
                                                <p className="sec-form-label">Stat Value</p>
                                                <input type="text" className="sec-form-input" defaultValue={item.stat_value} />
                                                <p className="sec-form-label">Label (EN)</p>
                                                <input type="text" className="sec-form-input" defaultValue={item.label_en} />
                                                <p className="sec-form-label">Label (AR)</p>
                                                <input type="text" className="sec-form-input" defaultValue={item.label_ar} dir="rtl" />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="sec-footer">
                                    <button className="sec-save-changes-btn" onClick={saveHero}>
                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 3H7L3 7v10a1 1 0 001 1h13a1 1 0 001-1V4a1 1 0 00-1-1zM7 3v5h7V3M7 13h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                        Save Changes
                                    </button>
                                </div>
                            </div>
                        )}

                        {activeTab === 'about' && (
                            <div className="sec-content">
                                <div className="sec-block">
                                    <h3 className="sec-block-title">Section Heading</h3>
                                    <div className="sec-form-row">
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Title Part 1 (EN)</label>
                                            <input type="text" className="sec-form-input" value={aboutForm.titleEn} onChange={(e) => setAboutForm({...aboutForm, titleEn: e.target.value})} />
                                        </div>
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Title Part 1 (AR)</label>
                                            <input type="text" className="sec-form-input" dir="rtl" value={aboutForm.titleAr} onChange={(e) => setAboutForm({...aboutForm, titleAr: e.target.value})} />
                                        </div>
                                    </div>
                                    <div className="sec-form-row">
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Highlighted Words (EN)</label>
                                            <input type="text" className="sec-form-input" value={aboutForm.titleEn2} onChange={(e) => setAboutForm({...aboutForm, titleEn2: e.target.value})} />
                                        </div>
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Highlighted Words (AR)</label>
                                            <input type="text" className="sec-form-input" dir="rtl" value={aboutForm.titleAr2} onChange={(e) => setAboutForm({...aboutForm, titleAr2: e.target.value})} />
                                        </div>
                                    </div>
                                    <div className="sec-form-row">
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Description (EN)</label>
                                            <textarea className="sec-form-textarea" value={aboutForm.desEn} onChange={(e) => setAboutForm({...aboutForm, desEn: e.target.value})}></textarea>
                                        </div>
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Description (AR)</label>
                                            <textarea className="sec-form-textarea" dir="rtl" value={aboutForm.desAr} onChange={(e) => setAboutForm({...aboutForm, desAr: e.target.value})}></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div className="sec-block">
                                    <div className="sec-block-header">
                                        <h3 className="sec-block-title">Feature Cards</h3>
                                        <button className="sec-add-btn" onClick={() => setFeatureModalOpen(true)}>
                                            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 4v12M4 10h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                                            Add Feature
                                        </button>
                                    </div>
                                    <div className="sec-feat-list">
                                        {featureCards.map((item) => (
                                            <div className="sec-feat-row" key={item.id}>
                                                <img src={item.icon_url} alt="icon" className="sec-feat-icon" />
                                                <div className="sec-feat-inputs">
                                                    <input type="text" className="sec-form-input" defaultValue={item.title_en} placeholder="Title (EN)" />
                                                    <input type="text" className="sec-form-input" defaultValue={item.title_ar} placeholder="Title (AR)" dir="rtl" />
                                                    <input type="text" className="sec-form-input" defaultValue={item.description_en} placeholder="Description (EN)" />
                                                    <input type="text" className="sec-form-input" defaultValue={item.description_ar} placeholder="Description (AR)" dir="rtl" />
                                                </div>
                                                <button className="sec-del-btn" onClick={() => handleDeleteFeatureCard(item.id)}>
                                                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 5h14M8 5V3h4v2M6 5l1 11h6l1-11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="sec-footer">
                                    <button className="sec-save-changes-btn" onClick={saveAbout}>
                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 3H7L3 7v10a1 1 0 001 1h13a1 1 0 001-1V4a1 1 0 00-1-1zM7 3v5h7V3M7 13h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                        Save Changes
                                    </button>
                                </div>
                            </div>
                        )}

                        {activeTab === 'booking' && (
                            <div className="sec-content">
                                <div className="sec-block">
                                    <h3 className="sec-block-title">Section Header</h3>
                                    <div className="sec-form-row">
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Section Title (EN)</label>
                                            <input type="text" className="sec-form-input" value={bookForm.secTitleEn} onChange={(e) => setBookForm({...bookForm, secTitleEn: e.target.value})} />
                                        </div>
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Section Title (AR)</label>
                                            <input type="text" className="sec-form-input" dir="rtl" value={bookForm.secTitleAr} onChange={(e) => setBookForm({...bookForm, secTitleAr: e.target.value})} />
                                        </div>
                                    </div>
                                    <div className="sec-form-row">
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Section Subtitle (EN)</label>
                                            <input type="text" className="sec-form-input" value={bookForm.secSubEn} onChange={(e) => setBookForm({...bookForm, secSubEn: e.target.value})} />
                                        </div>
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Section Subtitle (AR)</label>
                                            <input type="text" className="sec-form-input" dir="rtl" value={bookForm.secSubAr} onChange={(e) => setBookForm({...bookForm, secSubAr: e.target.value})} />
                                        </div>
                                    </div>
                                </div>
                                <div className="sec-block">
                                    <h3 className="sec-block-title">Booking Form Settings</h3>
                                    <div className="sec-form-row">
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Form Title (EN)</label>
                                            <input type="text" className="sec-form-input" value={bookForm.formTitleEn} onChange={(e) => setBookForm({...bookForm, formTitleEn: e.target.value})} />
                                        </div>
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Form Title (AR)</label>
                                            <input type="text" className="sec-form-input" dir="rtl" value={bookForm.formTitleAr} onChange={(e) => setBookForm({...bookForm, formTitleAr: e.target.value})} />
                                        </div>
                                    </div>
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Button Text</label>
                                        <input type="text" className="sec-form-input" value={bookForm.btnText} onChange={(e) => setBookForm({...bookForm, btnText: e.target.value})} />
                                    </div>
                                </div>
                                <div className="sec-block">
                                    <div className="sec-block-header">
                                        <h3 className="sec-block-title">Why Book With Us - Benefits</h3>
                                        <button className="sec-add-btn" onClick={() => setBenefitModalOpen(true)}>
                                            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 4v12M4 10h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                                            Add Benefit
                                        </button>
                                    </div>
                                    <div className="sec-benefits-grid">
                                        {bookingBenefits.map((item) => (
                                            <div className="sec-benefit-card" key={item.id}>
                                                <img src={item.img} alt="icon" className="sec-feat-icon" />
                                                <div className="sec-feat-inputs">
                                                    <input type="text" className="sec-form-input" defaultValue={item.title_en} placeholder="Title (EN)" />
                                                    <input type="text" className="sec-form-input" defaultValue={item.title_ar} placeholder="Title (AR)" dir="rtl" />
                                                    <input type="text" className="sec-form-input" defaultValue={item.description_en} placeholder="Description (EN)" />
                                                    <input type="text" className="sec-form-input" defaultValue={item.description_ar} placeholder="Description (AR)" dir="rtl" />
                                                </div>
                                                <button className="sec-del-btn" onClick={() => handleDeleteBenefit(item.id)}>
                                                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 5h14M8 5V3h4v2M6 5l1 11h6l1-11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="sec-block">
                                    <h3 className="sec-block-title">Support/Help Box</h3>
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Title</label>
                                        <input type="text" className="sec-form-input" value={bookForm.supportTitle} onChange={(e) => setBookForm({...bookForm, supportTitle: e.target.value})} />
                                    </div>
                                    <div className="sec-form-row">
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Support Email</label>
                                            <input type="text" className="sec-form-input" value={bookForm.supportEmail} onChange={(e) => setBookForm({...bookForm, supportEmail: e.target.value})} />
                                        </div>
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Support Phone</label>
                                            <input type="text" className="sec-form-input" value={bookForm.supportPhone} onChange={(e) => setBookForm({...bookForm, supportPhone: e.target.value})} />
                                        </div>
                                    </div>
                                </div>
                                <div className="sec-footer">
                                    <button className="sec-save-changes-btn" onClick={saveBooking}>
                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 3H7L3 7v10a1 1 0 001 1h13a1 1 0 001-1V4a1 1 0 00-1-1zM7 3v5h7V3M7 13h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                        Save Changes
                                    </button>
                                </div>
                            </div>
                        )}

                        {activeTab === 'featured' && (
                            <div className="sec-content">
                                <div className="sec-block-header" >
                                    <h3 className="sec-block-title">Featured Events</h3>
                                    <button className="sec-add-btn" onClick={() => setEventModalOpen(true)}>
                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 4v12M4 10h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                                        Add Event
                                    </button>
                                </div>
                                {featuredData.map((item) => (
                                    <div key={item.id}>
                                        <div className="sec-block">
                                            <h3 className="sec-block-title">Event Image</h3>
                                            <div className="sec-img-row">
                                                <img src={item.image_url} alt="featured event" className="sec-feat-icon"  />
                                                <button className="sec-upload-img-btn">
                                                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 13V4M10 4L7 7M10 4l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 13v3a1 1 0 001 1h12a1 1 0 001-1v-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
                                                    Upload Event Image
                                                </button>
                                            </div>
                                        </div>
                                        <div className="sec-block">
                                            <h3 className="sec-block-title">Event Details</h3>
                                            <div className="sec-form-row">
                                                <div className="sec-form-field">
                                                    <label className="sec-form-label">Event Title (EN)</label>
                                                    <input type="text" className="sec-form-input" defaultValue={item.title_en} />
                                                </div>
                                                <div className="sec-form-field">
                                                    <label className="sec-form-label">Event Title (AR)</label>
                                                    <input type="text" className="sec-form-input" defaultValue={item.title_ar} dir="rtl" />
                                                </div>
                                            </div>
                                            <div className="sec-form-row">
                                                <div className="sec-form-field">
                                                    <label className="sec-form-label">Event Date</label>
                                                    <input type="text" className="sec-form-input" defaultValue={item.event_date} />
                                                </div>
                                                <div className="sec-form-field">
                                                    <label className="sec-form-label">Event Time</label>
                                                    <input type="text" className="sec-form-input" defaultValue={item.event_time} />
                                                </div>
                                            </div>
                                            <div className="sec-form-row">
                                                <div className="sec-form-field">
                                                    <label className="sec-form-label">Location (EN)</label>
                                                    <input type="text" className="sec-form-input" defaultValue={item.location_en} />
                                                </div>
                                                <div className="sec-form-field">
                                                    <label className="sec-form-label">Location (AR)</label>
                                                    <input type="text" className="sec-form-input" defaultValue={item.location_ar} dir="rtl" />
                                                </div>
                                            </div>
                                            <div className="sec-form-field">
                                                <label className="sec-form-label">Starting Price</label>
                                                <input type="text" className="sec-form-input" defaultValue={item.starting_price} />
                                            </div>
                                        </div>
                                        <div className="sec-block">
                                            <div className="sec-block-header">
                                                <h3 className="sec-block-title">Event Tags</h3>
                                                <button className="sec-add-btn" onClick={() => setTagModalOpen(true)}>
                                                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 4v12M4 10h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                                                    Add Tag
                                                </button>
                                            </div>
                                            <div className="sec-tags">
                                                {eventTags.map((tag) => (
                                                    <span className="sec-tag" key={tag.id}>
                                                        {tag.Tag_en} / {tag.tag_ar}
                                                        <span className="sec-tag-x" onClick={() => handleDeleteTag(tag.id)}>×</span>
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="sec-block">
                                            <h3 className="sec-block-title">Call-to-Action Button</h3>
                                            <div className="sec-form-row">
                                                <div className="sec-form-field">
                                                    <label className="sec-form-label">Button Text</label>
                                                    <input type="text" className="sec-form-input" defaultValue={item.cta_button_text_en} />
                                                </div>
                                                <div className="sec-form-field">
                                                    <label className="sec-form-label">Button Link</label>
                                                    <input type="text" className="sec-form-input" defaultValue={item.cta_link} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div className="sec-footer">
                                    <button className="sec-save-changes-btn">
                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 3H7L3 7v10a1 1 0 001 1h13a1 1 0 001-1V4a1 1 0 00-1-1zM7 3v5h7V3M7 13h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                        Save Changes
                                    </button>
                                </div>
                            </div>
                        )}

                        {activeTab === 'testimonials' && (
                            <div className="sec-content">
                                <div className="sec-block">
                                    <h3 className="sec-block-title">Brand Info</h3>
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Brand Name</label>
                                        <input type="text" className="sec-form-input" defaultValue="FoxEvents" />
                                    </div>
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Brand Description</label>
                                        <textarea className="sec-form-textarea" defaultValue="Your premier destination for discovering and booking the most amazing events happening around you."></textarea>
                                    </div>
                                </div>
                                <div className="sec-block">
                                    <h3 className="sec-block-title">Social Media Links</h3>
                                    <div className="sec-form-row">
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Facebook URL</label>
                                            <input type="text" className="sec-form-input" defaultValue="https://facebook.com/foxevents" />
                                        </div>
                                        <div className="sec-form-field">
                                            <label className="sec-form-label">Twitter / X URL</label>
                                            <input type="text" className="sec-form-input" defaultValue="https://twitter.com/foxevents" />
                                        </div>
                                    </div>
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Instagram URL</label>
                                        <input type="text" className="sec-form-input" defaultValue="https://instagram.com/foxevents" />
                                    </div>
                                </div>
                                <div className="sec-block">
                                    <div className="sec-block-header">
                                        <h3 className="sec-block-title">Quick Links</h3>
                                        <button className="sec-add-btn" onClick={() => setNavModalOpen(true)}>
                                            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 4v12M4 10h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                                            Add Link
                                        </button>
                                    </div>
                                    <div className="sec-nav-table">
                                        <div className="sec-nav-head">
                                            <span>Link Text (EN)</span>
                                            <span>Link Text (AR)</span>
                                            <span>Delete</span>
                                        </div>
                                        {navData.map((item) => (
                                            <div className="sec-nav-row" key={item.id}>
                                                <input type="text" className="sec-form-input" defaultValue={item.label_en} />
                                                <input type="text" className="sec-form-input" defaultValue={item.label_ar} dir="rtl" />
                                                <button className="sec-del-btn" onClick={() => handleDeleteNav(item.id)}>
                                                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 5h14M8 5V3h4v2M6 5l1 11h6l1-11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="sec-block">
                                    <div className="sec-block-header">
                                        <h3 className="sec-block-title">Event Types</h3>
                                        <button className="sec-add-btn" onClick={() => setTagModalOpen(true)}>
                                            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 4v12M4 10h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                                            Add Type
                                        </button>
                                    </div>
                                    <div className="sec-footer-types-list">
                                        <div className="sec-nav-head">
                                            <span>Link Text (EN)</span>
                                            <span>Link Text (AR)</span>
                                            <span>Delete</span>
                                        </div>
                                        {eventTags.map((tag) => (
                                            <div className="sec-footer-type-row" key={tag.id}>
                                                <input type="text" className="sec-form-input" defaultValue={tag.Tag_en} placeholder="Tag (EN)" />
                                                <input type="text" className="sec-form-input" defaultValue={tag.tag_ar} placeholder="Tag (AR)" dir="rtl" />
                                                <button className="sec-del-btn" onClick={() => handleDeleteTag(tag.id)}>
                                                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 5h14M8 5V3h4v2M6 5l1 11h6l1-11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="sec-block">
                                    <h3 className="sec-block-title">Contact Info</h3>
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Email</label>
                                        <input type="text" className="sec-form-input" defaultValue={bookingData?.support_email} />
                                    </div>
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Phone</label>
                                        <input type="text" className="sec-form-input" defaultValue={bookingData?.support_phone} />
                                    </div>
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Address</label>
                                        <input type="text" className="sec-form-input" defaultValue="123 Event Street, San Francisco, CA 94102" />
                                    </div>
                                </div>
                                <div className="sec-block">
                                    <h3 className="sec-block-title">Bottom Bar</h3>
                                    <div className="sec-form-field">
                                        <label className="sec-form-label">Copyright Text</label>
                                        <input type="text" className="sec-form-input" defaultValue="© 2026 FoxEvents. All rights reserved." />
                                    </div>
                                </div>
                                <div className="sec-footer">
                                    <button className="sec-save-changes-btn">
                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 3H7L3 7v10a1 1 0 001 1h13a1 1 0 001-1V4a1 1 0 00-1-1zM7 3v5h7V3M7 13h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                        Save Changes
                                    </button>
                                </div>
                            </div>
                        )}
                    </>
                )}

            </DashLayout>
        </>
    );
};

export default Sections;